import { createFileRoute } from "@tanstack/react-router";
import TheRiskOfPtsdAfterACarAccident from "@/pages/TheRiskOfPtsdAfterACarAccident";
export const Route = createFileRoute(
  "/the-risk-of-ptsd-after-a-car-accident-how-to-recover",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "The Risk of PTSD After a Car Accident: How To Recover | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "PTSD after a car accident is common. Learn the signs, when to seek help, and treatment options like Prism neurofeedback in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "The Risk of PTSD After a Car Accident: How To Recover | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "PTSD after a car accident is common. Learn the signs, when to seek help, and treatment options like Prism neurofeedback in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/the-risk-of-ptsd-after-a-car-accident-how-to-recover",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/the-risk-of-ptsd-after-a-car-accident-how-to-recover",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TheRiskOfPtsdAfterACarAccident />;
}
